import { render } from "./index.vue?vue&type=template&id=ac326640&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=ac326640&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac326640"

export default script